import { Box, Tabs, Tab, useMediaQuery, useTheme, styled } from "@mui/material";
import TodayIcon from "@mui/icons-material/Today";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ViewListIcon from "@mui/icons-material/ViewList";
import { CALENDAR_VIEWS } from "../../const"; // Ajusta según tu ruta
import { useEffect, useState, useRef } from "react";
import { colors } from "../../../../ui/colors"; // Ajusta según tu ruta

const SegmentedControlContainer = styled(Box)(({ theme }) => ({
  backgroundColor: "var(--fx-surface-base, #FFFFFF)",
  borderRadius: "12px",
  padding: "4px",
  display: "inline-flex",
  alignItems: "center",
  width: "auto",
  minWidth: "300px",
}));

const StyledTabs = styled(Tabs)(({ theme }) => ({
  minHeight: 0,
  width: "100%",
  "& .MuiTabs-flexContainer": {
    gap: "4px",
  },
  "& .MuiTabs-indicator": {
    display: "none",
  },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: "none",
  minWidth: 0,
  flex: 1,
  fontWeight: 800,
  fontSize: "13px",
  color: "var(--fx-surface-textsecondary, #64748B)",
  borderRadius: "6px",
  padding: "5.6px 8px",
  minHeight: "32px",
  transition: "all 0.2s",
  margin: "4px 0",

  "&.Mui-selected": {
    color: "#fff",
    backgroundColor: colors.orange.base,
  },

  "&:hover": {
    backgroundColor: "transparent",
    "&.Mui-selected": {
      backgroundColor: colors.orange.base,
    },
  },

  "& .MuiTab-iconWrapper": {
    fontSize: "18px",
    marginRight: "8px",
  },
}));

interface ViewToggleProps {
  viewType: string;
  onViewChange: (newView: string) => void;
}

export const ViewToggle = ({ viewType, onViewChange }: ViewToggleProps) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const [activeViewIndex, setActiveViewIndex] = useState(0);
  const prevIsXsRef = useRef(isXs);

  const viewOptions = [
    { value: CALENDAR_VIEWS.DAY, label: "Day", icon: <TodayIcon /> },
    { value: CALENDAR_VIEWS.MONTH, label: "Month", icon: <CalendarMonthIcon />, disabled: isXs },
    { value: CALENDAR_VIEWS.LIST, label: "List", icon: <ViewListIcon /> },
  ];

  useEffect(() => {
    if (isXs && !prevIsXsRef.current && viewType !== CALENDAR_VIEWS.LIST) {
      onViewChange(CALENDAR_VIEWS.LIST);
    }
    prevIsXsRef.current = isXs;
  }, [isXs, viewType, onViewChange]);

  useEffect(() => {
    const newIndex = viewOptions.findIndex((option) => option.value === viewType);
    if (newIndex !== -1) setActiveViewIndex(newIndex);
  }, [viewType]);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    const selectedOption = viewOptions[newValue];
    if (!selectedOption.disabled) {
      onViewChange(selectedOption.value);
    }
  };

  return (
    <SegmentedControlContainer>
      <StyledTabs value={activeViewIndex} onChange={handleChange} variant="fullWidth">
        {viewOptions.map((option) => (
          <StyledTab key={option.value} label={option.label} icon={option.icon} iconPosition="start" disabled={option.disabled} />
        ))}
      </StyledTabs>
    </SegmentedControlContainer>
  );
};
